import React from 'react';
import { Main } from './components';

const ProductsWithoutStock = () => <Main />;

export default ProductsWithoutStock;
